import Vue from "vue";
import App from "../App/App.vue";
import EditProfile from "./EditProfile.vue";
var vm = window.$vm = new Vue({
    name: "App",
    el: "app",
    components: {
        App: App,
        EditProfile: EditProfile
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/Account/EditProfile.cshtml.ts
// module id = 915
// module chunks = 6